import Vue from "vue";
import VueRouter from "vue-router";
import GlobalGuards from "@/guards/Global";
import label from "@/lang/StaticLabels.js";

import TheContainer from "@/containers/TheContainer";
const Page404 = () => import("@/views/errors/Page404");
const Page403 = () => import("@/views/errors/Page403");
const Page500 = () => import("@/views/errors/Page500");
const PageUnderConstruction = () =>
  import("@/views/errors/PageUnderConstruction");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Container",
    component: TheContainer,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        meta: {
          label: label.page.dashboard,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/Dashboard"),
      },
      {
        path: "profile",
        name: "Profile",
        meta: {
          label: label.page.profile,
          requiresAuth: false,
        },
        component: () => import("@/views/auth/Profile"),
      },
      {
        path: "about",
        name: "About",
        meta: {
          label: label.page.aboutUs,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/AboutView"),
      },
      //  Base Information Routing System
      {
        path: "base",
        name: "BaseInformation",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/base/setting",
        children: [
          {
            path: "setting",
            name: "Setting",
            meta: {
              label: label.page.setting,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/base/setting"),
          },
          {
            path: "transactionInfo",
            name: "TransactionInfo",
            meta: {
              label: label.page.transactionInfo,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/base/transactionInfo"),
          },
          {
            path: "subscriber",
            name: "Subscriber",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/subscriber/list",
            children: [
              {
                path: "list",
                name: "SubscriberList",
                component: () => import("@/views/pages/base/subscriber"),
                meta: {
                  label: label.page.subscriber,
                  requiresAuth: true,
                },
              },
              {
                path: "add",
                name: "AddSubscriber",
                component: () => import("@/views/pages/base/subscriber/Info"),
                meta: {
                  label: label.page.addSubscriber,
                  requiresAuth: true,
                },
              },
              {
                path: "edit/:id",
                name: "EditSubscriber",
                component: () => import("@/views/pages/base/subscriber/Info"),
                meta: {
                  label: label.page.editSubscriber,
                  requiresAuth: true,
                },
              },
            ],
          },
          {
            path: "activityGroup",
            name: "ActivityGroup",
            meta: {
              label: label.page.activityGroup,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/base/activityGroup"),
          },
          {
            path: "internalUnit",
            name: "InternalUnit",
            meta: {
              label: label.page.internalUnit,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/base/internalUnit"),
          },
          {
            path: "automationType",
            name: "AutomationType",
            meta: {
              label: label.page.automationType,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/base/automationType"),
          },
          {
            path: "vehicle",
            name: "Vehicle",
            meta: {
              label: label.page.vehicle,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/base/vehicle"),
          },
          {
            path: "billboard",
            name: "Billboard",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/billboard/list",
            children: [
              {
                path: "list",
                name: "BillboardList",
                component: () => import("@/views/pages/base/billboard"),
                meta: {
                  label: label.page.billboard,
                  requiresAuth: true,
                },
              },
              {
                path: "add",
                name: "AddBillboard",
                component: () => import("@/views/pages/base/billboard/Info"),
                meta: {
                  label: label.page.addBillboard,
                  requiresAuth: true,
                },
              },
              {
                path: "edit/:id",
                name: "EditBillboard",
                component: () => import("@/views/pages/base/billboard/Info"),
                meta: {
                  label: label.page.editBillboard,
                  requiresAuth: true,
                },
              },
            ],
          },
          {
            path: "serviceType",
            name: "ServiceType",
            meta: {
              label: label.page.serviceType,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/base/serviceType"),
          },
          {
            path: "tariff",
            name: "Tariff",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/tariff/list",
            children: [
              {
                path: "list",
                name: "TariffList",
                component: () => import("@/views/pages/base/tariff"),
                meta: {
                  label: label.page.tariff,
                  requiresAuth: true,
                },
              },
              {
                path: "add",
                name: "AddTariff",
                component: () => import("@/views/pages/base/tariff/Info"),
                meta: {
                  label: label.page.addTariff,
                  requiresAuth: true,
                },
              },
              {
                path: "edit/:id",
                name: "EditTariff",
                component: () => import("@/views/pages/base/tariff/Info"),
                meta: {
                  label: label.page.editTariff,
                  requiresAuth: true,
                },
              },
            ],
          },
          {
            path: "waterBillPeriod",
            name: "WaterBillPeriod",
            meta: {
              label: label.page.waterBillPeriod,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/base/waterBillPeriod"),
          },
          {
            path: "notice",
            name: "Notice",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/notice/list",
            children: [
              {
                path: "list",
                name: "NoticeList",
                component: () => import("@/views/pages/base/notice"),
                meta: {
                  label: label.page.notice,
                  requiresAuth: true,
                },
              },
              {
                path: "add",
                name: "AddNotice",
                component: () => import("@/views/pages/base/notice/Info"),
                meta: {
                  label: label.page.addNotice,
                  requiresAuth: true,
                },
              },
              {
                path: "edit/:id",
                name: "EditNotice",
                component: () => import("@/views/pages/base/notice/Info"),
                meta: {
                  label: label.page.editNotice,
                  requiresAuth: true,
                },
              },
            ],
          },
        ],
      },

      //  Operation Routing System
      {
        path: "operation",
        name: "Operation",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/operation/subscriber",
        children: [
          {
            path: "transit",
            name: "Transit",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/transit/list",
            children: [
              {
                path: "list",
                name: "TransitList",
                component: () => import("@/views/pages/operation/transit"),
                meta: {
                  label: label.page.transit,
                  requiresAuth: true,
                },
              },
              {
                path: "add",
                name: "AddTransit",
                component: () => import("@/views/pages/operation/transit/Info"),
                meta: {
                  label: label.page.addTransit,
                  requiresAuth: true,
                },
              },
              {
                path: "edit/:id",
                name: "EditTransit",
                component: () => import("@/views/pages/operation/transit/Info"),
                meta: {
                  label: label.page.editTransit,
                  requiresAuth: true,
                },
              },
            ],
          },
          // {
          //   path: "fieldReport",
          //   name: "FieldReport",
          //   component: {
          //     render(c) {
          //       return c("router-view");
          //     },
          //   },
          //   redirect: "/fieldReport/list",
          //   children: [
          //     {
          //       path: "list",
          //       name: "FieldReportList",
          //       component: () => import("@/views/pages/operation/fieldReport"),
          //       meta: {
          //         label: label.page.fieldReport,
          //         requiresAuth: true,
          //       },
          //     },
          //     {
          //       path: "add",
          //       name: "AddFieldReport",
          //       component: () => import("@/views/pages/operation/fieldReport/Info"),
          //       meta: {
          //         label: label.page.addFieldReport,
          //         requiresAuth: true,
          //       },
          //     },
          //     {
          //       path: "edit/:id",
          //       name: "EditFieldReport",
          //       component: () => import("@/views/pages/operation/fieldReport/Info"),
          //       meta: {
          //         label: label.page.editFieldReport,
          //         requiresAuth: true,
          //       },
          //     },
          //   ],
          // },
          {
            path: "meterReading",
            name: "MeterReading",
            meta: {
              label: label.page.meterReading,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/operation/meterReading"),
          },
          {
            path: "waterBill",
            name: "WaterBill",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/waterBill/list",
            children: [
              {
                path: "list",
                name: "WaterBillList",
                component: () => import("@/views/pages/operation/waterBill"),
                meta: {
                  label: label.page.waterBill,
                  requiresAuth: true,
                },
              },
              {
                path: "edit/:id",
                name: "EditWaterBill",
                component: () =>
                  import("@/views/pages/operation/waterBill/Info"),
                meta: {
                  label: label.page.editWaterBill,
                  requiresAuth: true,
                },
              },
            ],
          },
          {
            path: "chargeBill",
            name: "ChargeBill",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/chargeBill/list",
            children: [
              {
                path: "list",
                name: "ChargeBillList",
                component: () => import("@/views/pages/operation/chargeBill"),
                meta: {
                  label: label.page.chargeBill,
                  requiresAuth: true,
                },
              },
              {
                path: "edit/:id",
                name: "EditChargeBill",
                component: () =>
                  import("@/views/pages/operation/chargeBill/Info"),
                meta: {
                  label: label.page.editChargeBill,
                  requiresAuth: true,
                },
              },
            ],
          },
          {
            path: "automation",
            name: "Automation",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/automation/list",
            children: [
              {
                path: "list",
                name: "AutomationList",
                component: () => import("@/views/pages/operation/automation"),
                meta: {
                  label: label.page.automation,
                  requiresAuth: true,
                },
              },
              {
                path: "add",
                name: "AddAutomation",
                component: () =>
                  import("@/views/pages/operation/automation/Info"),
                meta: {
                  label: label.page.addAutomation,
                  requiresAuth: true,
                },
              },
              {
                path: "edit/:id",
                name: "EditAutomation",
                component: () =>
                  import("@/views/pages/operation/automation/Info"),
                meta: {
                  label: label.page.editAutomation,
                  requiresAuth: true,
                },
              },
            ],
          },
          {
            path: "billboardRequest",
            name: "BillboardRequest",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/billboardRequest/list",
            children: [
              {
                path: "list",
                name: "BillboardRequestList",
                component: () =>
                  import("@/views/pages/operation/billboardRequest"),
                meta: {
                  label: label.page.billboardRequest,
                  requiresAuth: true,
                },
              },
              {
                path: "add",
                name: "AddBillboardRequest",
                component: () =>
                  import("@/views/pages/operation/billboardRequest/Info"),
                meta: {
                  label: label.page.addBillboardRequest,
                  requiresAuth: true,
                },
              },
              {
                path: "edit/:id",
                name: "EditBillboardRequest",
                component: () =>
                  import("@/views/pages/operation/billboardRequest/Info"),
                meta: {
                  label: label.page.editBillboardRequest,
                  requiresAuth: true,
                },
              },
            ],
          },
          {
            path: "serviceRequest",
            name: "ServiceRequest",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/serviceRequest/list",
            children: [
              {
                path: "list",
                name: "ServiceRequestList",
                component: () =>
                  import("@/views/pages/operation/serviceRequest"),
                meta: {
                  label: label.page.serviceRequest,
                  requiresAuth: true,
                },
              },
              {
                path: "add",
                name: "AddServiceRequest",
                component: () =>
                  import("@/views/pages/operation/serviceRequest/Info"),
                meta: {
                  label: label.page.addServiceRequest,
                  requiresAuth: true,
                },
              },
              {
                path: "edit/:id",
                name: "EditServiceRequest",
                component: () =>
                  import("@/views/pages/operation/serviceRequest/Info"),
                meta: {
                  label: label.page.editServiceRequest,
                  requiresAuth: true,
                },
              },
            ],
          },
          {
            path: "voucher",
            name: "VoucherCartable",
            meta: {
              label: label.page.voucherCartable,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/operation/voucherCartable"),
          },
        ],
      },

      {
        path: "/payment/result",
        name: "PaymentResult",
        meta: {
          label: "نتیجه پرداخت اینترنتی",
          requiresAuth: false,
        },
        component: () => import("@/views/pages/operation/payment/result.vue"),
      },

      //  Identity Routing System
      {
        path: "identity",
        name: "Identity",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/identity/role",
        children: [
          {
            path: "role",
            name: "Roles",
            component: () => import("@/views/pages/identity/role/index"),
            meta: {
              label: label.page.roles,
              requiresAuth: true,
            },
          },
          {
            path: "permission/:id?",
            name: "RolePermissions",
            component: () => import("@/views/pages/identity/role/Permission"),
            meta: {
              label: label.page.permissions,
              requiresAuth: true,
            },
          },
          {
            path: "users",
            name: "Users",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/users/list",
            children: [
              {
                path: "list",
                name: "UserList",
                component: () => import("@/views/pages/identity/user"),
                meta: {
                  label: label.page.user,
                  requiresAuth: true,
                },
              },
              {
                path: "add",
                name: "AddUser",
                component: () => import("@/views/pages/identity/user/Info"),
                meta: {
                  label: label.page.addUser,
                  requiresAuth: true,
                },
              },
              {
                path: "edit/:id",
                name: "EditUser",
                component: () => import("@/views/pages/identity/user/Info"),
                meta: {
                  label: label.page.editUser,
                  requiresAuth: true,
                },
              },
            ],
          },
          {
            path: "person",
            name: "Person",
            component: () => import("@/views/pages/identity/person"),
            meta: {
              label: label.page.person,
              requiresAuth: true,
            },
          },
        ],
      },

      //  Report Routing System
      {
        path: "report",
        name: "Report",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/report/transactionReport",
        children: [
          {
            path: "transactionReport",
            name: "TransactionReport",
            meta: {
              label: label.page.transactionReport,
              requiresAuth: true,
            },
            component: () => import("@/views/pages/report/transactionReport"),
          },
        ],
      },
      {
        path: "rejected",
        name: "RejectedTemplate",
        meta: {
          label: label.page.noAccess,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/RejectedTemplate"),
      },
    ],
  },

  // other Pages - without container
  {
    path: "/login",
    name: "Login",
    meta: {
      label: label.page.login,
    },
    component: () => import("@/views/auth/Login"),
    beforeEnter(to, from, next) {
      GlobalGuards.login(to, from, next);
    },
  },
  {
    path: "/register",
    name: "Register",
    meta: {
      label: label.page.register,
    },
    component: () => import("@/views/auth/Register"),
    // beforeEnter(to, from, next) {
    //   GlobalGuards.login(to, from, next);
    // },
  },

  {
    path: "/pages",
    redirect: "/pages/404",
    name: "Pages",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "404",
        name: "Page404",
        component: Page404,
      },
      {
        path: "403",
        name: "Page403",
        component: Page403,
      },
      {
        path: "500",
        name: "Page500",
        component: Page500,
      },
      {
        path: "underConstruction",
        name: "PageUnderConstruction",
        component: PageUnderConstruction,
      },
    ],
  },

  {
    path: "*",
    component: Page404,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

router.beforeEach((to, from, next) => GlobalGuards.beforeEach(to, from, next));
router.afterEach((to, from) => GlobalGuards.afterEach(to, from));

export default router;
